import PropTypes from 'prop-types'
import classNames from 'classnames'
import InstagramEmbed from 'react-instagram-embed'
import Card from 'components/card'
import Link from 'components/link'
import { FB_APP_ID, FB_CLIENT_TOKEN } from 'shared/constants'
import css from './feed-items.scss'

const InstagramCard = ({ embedCode, url }) => {
  return (
    <Link url={url} newWindow>
      <Card className={classNames(css.instagramLayout, 'mbxl')}>
        <InstagramEmbed
          url={url}
          accessToken={`${FB_APP_ID}|${FB_CLIENT_TOKEN}`}
        />
      </Card>
    </Link>
  )
}

InstagramCard.propTypes = {
  embedCode: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

export default InstagramCard
